module.exports = __webpack_public_path__ + "static/media/map_corner_photo_charles_nye.21fdc046.png";